import { render, staticRenderFns } from "./InvoiceAuditTabs.vue?vue&type=template&id=67e86068&scoped=true"
import script from "./InvoiceAuditTabs.vue?vue&type=script&lang=js"
export * from "./InvoiceAuditTabs.vue?vue&type=script&lang=js"
import style0 from "./InvoiceAuditTabs.vue?vue&type=style&index=0&id=67e86068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e86068",
  null
  
)

export default component.exports